import { Chip, Grid, TextField, Tooltip, makeStyles } from '@material-ui/core';
import _, { isEmpty, isFunction } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Field } from 'react-final-form';
import { Autocomplete } from '@material-ui/lab';
import { selectCatalogosProdutos } from '../../features/catalogo-produtos/catalogoProdutosSlice';
import { selectMercadoriaCount, selectRelatedMercadoriaModel } from '../../features/fatura/faturaSelectors';
import { ncmSubitemActions } from '../../features/ncm-subitem/ncmSubitemSlice';
import { nveAtributoActions } from '../../features/nve-atributo/nveAtributoSlice';
import { nveEspecificacaoActions } from '../../features/nve-especificacao/nveEspecificacaoSlice';
import { nveActions } from '../../features/nve/nveSlice';
import { unidadeDeMedidaActions } from '../../features/unidade-medida/unidadeDeMedidaSlice';
import QCXFinalMultilineTextField from '../../shared-components/final-text-field/QCXFinalMultilineTextField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import { getTipoCalculoValue } from '../../shared-components/select-forma-calculo/formaCalculoUtils';
import QCXCustomRegistrationTabControlTemplate from '../../templates/custom-registration-one-to-many-page/QCXCustomRegistrationTabControlTemplate';
import useCatalogoProdutosAtributosListeners from '../../utils/general/catalogo-produtos/catalogoProdutosAtributosListeners';
import useFaturaMercadoriaListeners from '../../utils/general/fatura/faturaMercadoriaListeners';
import { TIPO_FATURA, getPendenciasFaturaOcr } from '../../utils/general/fatura/faturaUtils';
import { unnormalizeNumeral } from '../../utils/general/general-utils';
import { forceParseToFixedNumber } from '../../utils/general/parse-utils';
import { formatBrazilianNumericDecimal } from '../../utils/hooks/form/field/formatters';
import useExternallyFilling from '../../utils/hooks/form/field/useExternallyFilling';
import QCXFinalAtributoNveBondManager from '../declaracao-importacao/QCXFinalAtributoNveBondManager';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXFaturaAdicionaisFormGroup from './QCXFaturaAdicionaisFormGroup';
import QCXFaturaForceTabReload from './QCXFaturaForceTabReload';
import QCXFaturaMercadoriaStandardFormGroup from './QCXFaturaMercadoriaStandardFormGroup';
import QCXFaturaIntegracaoFormGroup from './QCXFaturaIntegracaoFormGroup';
import QCXFinalLotesBondManager from './FaturaMercadoriaForm/QCXFinalLotesBondManager';
import QCXFaturaAtributosNcmDinamico from './QCXFaturaAtributosNcmDinamico';
import TableCellWithTooltip from '../../shared-components/tooltip-cell/TableCellWithTooltip';
import { fetchMercadoriaPaginatedAsync } from '../../features/fatura/faturaThunks';

const useStyles = makeStyles((theme) => ({
  destaqueNcmFieldLeft: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '16px',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '16px',
    },
  },
}));

export default function QCXFaturaMercadoriaForm({
  isIdle,
  isLoading,
  isPreparingAction,
  isCreate,
  isConsult,
  isUpdate,
  isSubNone,
  isSubCreate,
  isSubConsult,
  isSubUpdate,
  isBackgroundDelete,
  isSubBackgroundCreate,
  isSubBackgroundUpdate,
  isSubBackgroundDelete,
  faturaValues,
  initialValues,
  fatura,
  tipo = TIPO_FATURA,
  defaultItem,
  handleSubmit,
  handleNew,
  handleEdit,
  handleChangeToSubConsult,
  handleChangeModel,
  handleCancelCreate,
  handleCancelUpdate,
  handleChangeToConsult,
  handleRemoveByForm,
  handleRemoveByTable,
  handleClearForm,
  handleChangeToSubNone,
  handleChangeToUpdate,
  handleMetadataUpdate,
  handleLoadingStatus,
  handleResetStatus,
  controlComponentProps,
  tabManagerProps = {},
  formPaginationControlProps = {},
  buttonGroupOptions = {},
  authInfo = {},
  ...restProps
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const params = useParams();

  const faturaId = params?.id ?? fatura?.id;

  const importadorId = faturaValues?.importador?.id;

  const classes = useStyles();

  const [isFirstFormLoadValues, setIsFirstFormLoadValues] = useState(true);
  const [isFilling, subscribeToFilling] = useExternallyFilling();

  const [isQuantidade, setIsQuantidadeUnidade] = useState(false);
  const [isQuilograma, setIsQuilogramaUnidade] = useState(false);

  const unidadeMedidaList = useSelector(unidadeDeMedidaActions.selectUnidadesdeMedida);
  const listCatalogo = useSelector(selectCatalogosProdutos);
  const ncmList = useSelector(ncmSubitemActions.selectNcmSubitens);

  const mercadoriasCount = useSelector(selectMercadoriaCount);
  const mercadorias = fatura?.mercadorias;

  useEffect(() => {
    if (isSubNone) {
      setIsFirstFormLoadValues(true);
    }
  }, [isSubNone]);

  const isDadosEmComumFornecedor = useMemo(() => faturaValues?.dadosComumFornecedor, [faturaValues]);

  const isSobrescreveDadosPartnumber = useMemo(() => faturaValues?.sobrescreveDadosPartnumber, [faturaValues]);
  const isNpi = useMemo(() => faturaValues?.isNpi, [faturaValues]);

  const isFillCommonDataMode = useMemo(
    () => isSubCreate && isDadosEmComumFornecedor,
    [isSubCreate, isDadosEmComumFornecedor]
  );

  const internalInitialValues = useMemo(
    () =>
      isFillCommonDataMode
        ? {
            ...initialValues,
            partnumberAutocompleteSelector: initialValues?.partnumber,
            relacao: faturaValues?.relacao,
            exportador: faturaValues?.exportador?.id
              ? {
                  id: faturaValues?.exportador?.id,
                }
              : undefined,
            fabricante: faturaValues?.fabricante?.id
              ? {
                  id: faturaValues?.fabricante?.id,
                }
              : undefined,
            paisOrigem: faturaValues?.paisOrigem?.id
              ? {
                  id: faturaValues?.paisOrigem?.id,
                }
              : undefined,
          }
        : {
            partnumberAutocompleteSelector: initialValues?.partnumber,
            partNumberSelector: initialValues?.partnumber,
            ...initialValues,
          },
    [isFillCommonDataMode, initialValues, faturaValues]
  );

  const handleAlternativeSaveMercadoria = useCallback(() => {
    if (isEmpty(controlComponentProps) || !isFunction(controlComponentProps?.handleAlternativeSave)) {
      throw Error('Error: "handleAlternativeSave" is not a function.');
    }

    const { handleAlternativeSave } = controlComponentProps;
    const mercadoriaStepIndex = 3;

    handleAlternativeSave(null, mercadoriaStepIndex);
  }, [controlComponentProps]);

  useEffect(() => {
    dispatch(
      fetchMercadoriaPaginatedAsync({
        faturaId,
        page: 1,
        size: 10,
      })
    );
  }, [faturaId]);

  const handleConfigChange = useCallback(
    ({ currentPage, pageSize, filterInputValue }) => {
      dispatch(
        fetchMercadoriaPaginatedAsync({
          faturaId,
          page: currentPage,
          size: pageSize,
          search: filterInputValue,
        })
      );
    },
    [faturaId, fetchMercadoriaPaginatedAsync]
  );

  const tableProps = useMemo(
    () => ({
      title: t('com.muralis.qcx.mercadoria.mercadoriasAdicionais'),
      showDuplicar: true,
      rowsCount: mercadoriasCount,
      onConfigChangeCallback: handleConfigChange,
      columns: [
        {
          field: 'id',
          headerName: t('com.muralis.qcx.item.labelSingular'),
          headerAlign: 'center',
          align: 'center',
          flex: 60,
          valueGetter: ({ row }) => row?.item,
        },
        {
          field: 'partnumber',
          headerName: t('com.muralis.qcx.item.partNumber'),
          flex: 120,
          renderCell: ({ row }) => (
            <TableCellWithTooltip value={row?.partnumber || t('com.muralis.qcx.validacao.naoPreenchido')} />
          ),
          valueGetter: ({ row }) => row?.partnumber,
        },
        {
          field: 'descricaoResumida',
          headerName: t('com.muralis.qcx.mercadoria.descricaoResumida'),
          flex: 160,
          renderCell: ({ row }) => <TableCellWithTooltip value={row?.descricaoResumida} />,
          valueGetter: ({ row }) => row?.descricaoResumida,
        },
        {
          field: 'quebraAuxiliar',
          headerName: t('com.muralis.qcx.mercadoria.quebraAd'),
          width: 140,
          valueGetter: ({ row }) => row?.quebraAuxiliar || '',
          headerAlign: 'center',
          align: 'center',
        },
        {
          field: 'quantidade',
          headerName: t('com.muralis.qcx.quantidade.short'),
          headerAlign: 'center',
          align: 'center',
          flex: 80,
          valueFormatter: ({ row: { quantidade } }) => unnormalizeNumeral(forceParseToFixedNumber(quantidade), 5),
        },
        {
          field: 'valorTotalMcvMoeda',
          headerName: t('com.muralis.qcx.mercadoria.totalMCV'),
          headerAlign: 'right',
          align: 'right',
          flex: 100,
          valueFormatter: ({ row: { valorTotalMcvMoeda } }) =>
            unnormalizeNumeral(valorTotalMcvMoeda, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'valorTotalMoeda',
          headerName: t('com.muralis.qcx.mercadoria.valorTotalItem'),
          headerAlign: 'right',
          align: 'right',
          flex: 100,
          valueFormatter: ({ row: { valorTotalMoeda } }) =>
            unnormalizeNumeral(valorTotalMoeda, formatBrazilianNumericDecimal(2)) || '-',
        },
        {
          field: 'erroOcr',
          // headerName: 'Status OCR',
          headerName: 'OCR' ?? t('com.muralis.qcx.mercadoria.statusOCR.label'),
          headerAlign: 'center',
          align: 'center',
          flex: 70,
          renderCell: ({ row: { erroOcr } }) => {
            switch (erroOcr) {
              case false:
                return <Chip size="small" label={t('com.muralis.qcx.mercadoria.statusOCR.ok')} color="primary" />;
              case true:
                return (
                  <Tooltip title={t('com.muralis.qcx.mercadoria.statusOCR.mensagemPendencia')}>
                    <Chip size="small" label={t('com.muralis.qcx.mercadoria.statusOCR.pendencia')} color="secondary" />
                  </Tooltip>
                );
              default:
                return <></>;
            }
          },
        },
        {
          field: 'versao',
          headerName: 'Versão',
          headerAlign: 'center',
          align: 'center',
          flex: 70,
          renderCell: ({ row }) => <TableCellWithTooltip value={row?.versaoCatalogo} />,
          valueGetter: ({ row }) => row?.versaoCatalogo,
        },
        {
          field: 'codigo',
          headerName: 'Código',
          headerAlign: 'center',
          align: 'center',
          flex: 70,
          renderCell: ({ row }) => <TableCellWithTooltip value={row?.codigoCatalogo} />,
          valueGetter: ({ row }) => row?.codigoCatalogo,
        },
      ],
    }),
    [mercadoriasCount, handleConfigChange]
  );

  const localeTableText = useMemo(
    () => ({
      noRowsLabel: t('com.muralis.qcx.mercadoria.nenhumaMercadoriaEncontrada'),
    }),
    []
  );

  const currentTitleSubPage = useMemo(
    () =>
      isSubCreate ? t('com.muralis.qcx.mercadoria.novaMercadoria') : t('com.muralis.qcx.mercadoria.dadosMercadoria'),
    [isSubCreate]
  );

  const modes = useMemo(
    () => ({
      isConsult,
      isSubConsult,
      isSubNone,
      isSubCreate,
      isSubUpdate,
      isFillCommonDataMode,
    }),
    [isConsult, isSubConsult, isSubNone, isSubCreate, isSubUpdate, isFillCommonDataMode]
  );

  const formProps = useMemo(
    () => ({
      faturaValues,
      listCatalogo,
      unidadeMedidaList,
      isFirstFormLoadValues,
      setIsFirstFormLoadValues,
      rootName: 'adicionais',
    }),
    [faturaValues, listCatalogo, unidadeMedidaList, isFirstFormLoadValues, setIsFirstFormLoadValues]
  );

  const quantidadeEstatisticaProps = useMemo(
    () => ({
      isQuantidade,
      isQuilograma,
      setIsQuantidadeUnidade,
      setIsQuilogramaUnidade,
    }),
    [isQuantidade, isQuilograma, setIsQuantidadeUnidade, setIsQuilogramaUnidade]
  );

  const [onBlurObjectHandlers, changeListeners] = useFaturaMercadoriaListeners({
    modes,
    formProps,
    subscribeToFilling,
    isSobrescreveDadosPartnumber,
    quantidadeEstatisticaProps,
    getTipoCalculoValue,
  });

  const catalogoProdutoActions = useMemo(
    () => ({
      nveActions,
      nveAtributoActions,
      nveEspecificacaoActions,
    }),
    [nveActions, nveAtributoActions, nveEspecificacaoActions]
  );

  const catalogoProdutoFormProps = useMemo(
    () => ({
      ncmList,
    }),
    [ncmList]
  );

  const catalogoProdutosAtributosChangeListeners = useCatalogoProdutosAtributosListeners({
    rootName: 'ignorableFields.atributoNve',
    modes,
    actions: catalogoProdutoActions,
    formProps: catalogoProdutoFormProps,
  });

  changeListeners.push(...catalogoProdutosAtributosChangeListeners);

  return (
    <QCXFormStepWizard
      initialValues={internalInitialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      onChangeListeners={changeListeners}
      alternativeMode
      {...restProps}
    >
      {({ form, submitting, submitSucceeded }) => (
        <QCXCustomRegistrationTabControlTemplate
          initialValues={internalInitialValues}
          title={currentTitleSubPage}
          tableProps={tableProps}
          tableData={mercadorias}
          isPreparingAction={isPreparingAction}
          isIdle={isIdle}
          isLoading={isLoading}
          isCreate={isCreate}
          isConsult={isConsult}
          isUpdate={isUpdate}
          isSubNone={isSubNone}
          isSubCreate={isSubCreate}
          isSubConsult={isSubConsult}
          isSubUpdate={isSubUpdate}
          isBackgroundDelete={isBackgroundDelete}
          isSubBackgroundCreate={isSubBackgroundCreate}
          isSubBackgroundUpdate={isSubBackgroundUpdate}
          isSubBackgroundDelete={isSubBackgroundDelete}
          submitting={submitting}
          submitSucceeded={submitSucceeded}
          selectModel={selectRelatedMercadoriaModel}
          defaultItem={defaultItem}
          handleNew={handleNew}
          handleEdit={handleEdit}
          handleChangeToSubConsult={handleChangeToSubConsult}
          handleChangeModel={handleChangeModel}
          handleCancelCreate={handleCancelCreate}
          handleCancelUpdate={handleCancelUpdate}
          handleChangeToConsult={handleChangeToConsult}
          handleRemoveByForm={handleRemoveByForm}
          handleRemoveByTable={handleRemoveByTable}
          handleClearForm={handleClearForm}
          defaultRestartedValues={{
            partnumberAutocompleteSelector: '',
            partNumberSelector: '',
            partnumber: '',
            descricaoResumida: '',
            pesoLiquido: '',
            pesoLiquidoUnitario: '',
            valorUnitarioMoeda: '',
            destaqueNcm: '',
            adicionais: {
              numeroSerie: '',
              marca: '',
              modelo: '',
              dataValidade: '',
              anoFabricacao: '',
              lote: '',
              especificacao: '',
            },
            totvsLi: '',
            numeroSerieDuimp: '',
            quantidadeEstatistica: '',
            quantidade: '',
            valorTotalMoeda: '',
            percentualDesconto: '',
            valorTotalMcvMoeda: '',
            tipoCalculo: 'QUANTIDADE_X_VALOR',
            icms: '',
          }}
          handleChangeToSubNone={handleChangeToSubNone}
          handleChangeToUpdate={handleChangeToUpdate}
          handleLoadingStatus={handleLoadingStatus}
          handleResetStatus={handleResetStatus}
          localeTableText={localeTableText}
          filterPropGetter={(row) => row?.partnumber}
          handleAlternativeSave={handleAlternativeSaveMercadoria}
          handleMetadataUpdate={handleMetadataUpdate}
          tabManagerProps={tabManagerProps}
          formPaginationControlProps={formPaginationControlProps}
          buttonGroupOptions={buttonGroupOptions}
          form={form}
          gridPaginated
        >
          {() => (
            <>
              <QCXFaturaForceTabReload />

              <QCXFaturaMercadoriaStandardFormGroup
                key={JSON.stringify(internalInitialValues)}
                tipo={tipo}
                modes={modes}
                classes={classes}
                isFilling={isFilling}
                quantidadeEstatisticaProps={quantidadeEstatisticaProps}
                onBlurObjectHandlers={onBlurObjectHandlers}
                fatura={fatura}
                authInfo={authInfo}
                isFatura
                importadorId={importadorId}
              />

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFormTitle title={t('com.muralis.qcx.integracao.label')} />
              </Grid>
              <QCXFaturaIntegracaoFormGroup modes={modes} />

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFormTitle title="ATRIBUTOS" />
              </Grid>
              
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  name="numeroSerieDuimp" 
                  parse={(value) => (Array.isArray(value) ? value.join(';') : value)}
                  format={(value) => (value ? value.split(';') : [])}
                >
                  {({ input, meta }) => (
                    <Autocomplete
                      {...input}
                      multiple
                      freeSolo
                      options={[]} 
                      disabled={modes.isConsult || modes.isSubConsult || modes.isSubNone}
                      value={input.value || []}
                      onChange={(e, newValue) => input.onChange(newValue)}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                        ))
                      }
                      renderInput={(inputParams) => (
                        <TextField
                          {...inputParams}
                          variant="outlined"
                          label="Número Série (DUIMP)"
                          placeholder={input.value && input.value.length > 0 ? '' : 'Digite o serial e pressione Enter'}
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                          InputLabelProps={{
                            ...inputParams.InputLabelProps,
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  )}
                </Field>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFormTitle title={t('com.muralis.qcx.adicionais')} />
              </Grid>
              <QCXFaturaAdicionaisFormGroup modes={modes} />

              {!(isConsult || isSubNone || isSubCreate) && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <QCXFinalMultilineTextField
                    id="text-especificacao-multiline-field"
                    key="text-especificacao-multiline-field"
                    name="adicionais.especificacaoCompleta"
                    label={t('com.muralis.qcx.especificacao.especificacaoCompletaMercadoria')}
                    disabled={isConsult || isSubConsult || isSubNone}
                    rows={5}
                    InputProps={{
                      readOnly: true,
                    }}
                    helperText={
                      !(isConsult || isSubNone || isSubConsult) && t('com.muralis.qcx.mensagem.campoHabilitadoLeitura')
                    }
                  />
                </Grid>
              )}

              <>
                <Grid item className={classes.subtitle} xs={12}>
                  <QCXFormSubtitle title="Lotes" />
                </Grid>

                <QCXFinalLotesBondManager
                  classes={classes}
                  modes={modes}
                  listProps={{
                    rootName: 'lotes',
                  }}
                  isParentConsult={isConsult}
                />
              </>

              <>
                <Grid item className={classes.subtitle} xs={12}>
                  <QCXFormSubtitle title={t('com.muralis.qcx.NVE.NVEatributos')} />
                </Grid>
                <QCXFinalAtributoNveBondManager
                  classes={classes}
                  modes={modes}
                  listProps={{
                    rootName: 'atributos',
                  }}
                />
              </>
              {isNpi ? (
                <>
                  <QCXFaturaAtributosNcmDinamico modes={modes} />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </QCXCustomRegistrationTabControlTemplate>
      )}
    </QCXFormStepWizard>
  );
}
